/*! js-cookie v3.0.0-rc.0 | MIT */
!function (e, t) {
    "object" == typeof exports && "undefined" != typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define(t) : (e = e || self, function () {
        var r = e.Cookies, n = e.Cookies = t();
        n.noConflict = function () {
            return e.Cookies = r, n
        }
    }())
}(this, function () {
    "use strict";

    function e(e) {
        for (var t = 1; t < arguments.length; t++) {
            var r = arguments[t];
            for (var n in r) e[n] = r[n]
        }
        return e
    }

    var t = {
        read: function (e) {
            return e.replace(/%3B/g, ";")
        }, write: function (e) {
            return e.replace(/;/g, "%3B")
        }
    };
    return function r(n, i) {
        function o(r, o, u) {
            if ("undefined" != typeof document) {
                "number" == typeof (u = e({}, i, u)).expires && (u.expires = new Date(Date.now() + 864e5 * u.expires)), u.expires && (u.expires = u.expires.toUTCString()), r = t.write(r).replace(/=/g, "%3D"), o = n.write(String(o), r);
                var c = "";
                for (var f in u) u[f] && (c += "; " + f, !0 !== u[f] && (c += "=" + u[f].split(";")[0]));
                return document.cookie = r + "=" + o + c
            }
        }

        return Object.create({
            set: o, get: function (e) {
                if ("undefined" != typeof document && (!arguments.length || e)) {
                    for (var r = document.cookie ? document.cookie.split("; ") : [], i = {}, o = 0; o < r.length; o++) {
                        var u = r[o].split("="), c = u.slice(1).join("="), f = t.read(u[0]).replace(/%3D/g, "=");
                        if (i[f] = n.read(c, f), e === f) break
                    }
                    return e ? i[e] : i
                }
            }, remove: function (t, r) {
                o(t, "", e({}, r, {expires: -1}))
            }, withAttributes: function (t) {
                return r(this.converter, e({}, this.attributes, t))
            }, withConverter: function (t) {
                return r(e({}, this.converter, t), this.attributes)
            }
        }, {attributes: {value: Object.freeze(i)}, converter: {value: Object.freeze(n)}})
    }(t, {path: "/"})
});

(function () {

    function el(id) {
        return document.getElementById(id);
    }

    function cookieAgreement() {
        const cc = Cookies.get('CC');
        if (!cc) {
            el("cc-overlay").style.display = '';

            // Accept button
            el("cc-agree").addEventListener('click', function () {
                Cookies.set('CC', 'YES', {expires: 3650});    // 10 years
                el("cc-overlay").style.display = 'none';
            });
        }
    }

    function makeNavAccessible() {
        const allNavLinks = document.querySelectorAll('a[tabindex="-1"], .nav-link, .navbar-nav a, .dropdown-item');

        allNavLinks.forEach(function (link) {
            link.setAttribute('tabindex', '0');
        });


        const dropdownToggles = document.querySelectorAll('.dropdown .nav-link, .nav-item.dropdown > a');

        dropdownToggles.forEach(function (toggle) {
            const parentItem = toggle.closest('.dropdown, .nav-item');
            const dropdownMenu = parentItem ? parentItem.querySelector('.dropdown-menu, .child-menu') : null;

            if (!dropdownMenu) return;


            toggle.addEventListener('focus', function () {
                dropdownMenu.classList.add('show');
                parentItem.classList.add('show');
            });


            toggle.addEventListener('keydown', function (e) {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    const isOpen = dropdownMenu.classList.contains('show');
                    if (isOpen) {
                        dropdownMenu.classList.remove('show');
                        parentItem.classList.remove('show');
                    } else {
                        dropdownMenu.classList.add('show');
                        parentItem.classList.add('show');
                        const firstLink = dropdownMenu.querySelector('a');
                        if (firstLink) {
                            setTimeout(() => firstLink.focus(), 50);
                        }
                    }
                } else if (e.key === 'ArrowDown') {
                    e.preventDefault();
                    dropdownMenu.classList.add('show');
                    parentItem.classList.add('show');
                    const firstLink = dropdownMenu.querySelector('a');
                    if (firstLink) firstLink.focus();
                } else if (e.key === 'Escape') {
                    dropdownMenu.classList.remove('show');
                    parentItem.classList.remove('show');
                    toggle.focus();
                }
            });


            const submenuLinks = dropdownMenu.querySelectorAll('a');
            submenuLinks.forEach(function (link, index) {
                link.setAttribute('tabindex', '0');

                link.addEventListener('keydown', function (e) {
                    if (e.key === 'ArrowDown') {
                        e.preventDefault();
                        const next = submenuLinks[index + 1];
                        if (next) next.focus();
                    } else if (e.key === 'ArrowUp') {
                        e.preventDefault();
                        if (index === 0) {
                            toggle.focus();
                        } else {
                            submenuLinks[index - 1].focus();
                        }
                    } else if (e.key === 'Escape') {
                        e.preventDefault();
                        dropdownMenu.classList.remove('show');
                        parentItem.classList.remove('show');
                        toggle.focus();
                    }
                });


                link.addEventListener('blur', function (e) {
                    setTimeout(function () {
                        if (!parentItem.contains(document.activeElement)) {
                            dropdownMenu.classList.remove('show');
                            parentItem.classList.remove('show');
                        }
                    }, 100);
                });
            });
        });


        if (!document.getElementById('nav-focus-styles')) {
            const style = document.createElement('style');
            style.id = 'nav-focus-styles';
            style.textContent = `
                .nav-link:focus,
                .navbar-nav a:focus,
                .dropdown-item:focus,
                a[role="menuitem"]:focus {
                    outline: 3px solid #0B5FFF !important;
                    outline-offset: 2px !important;
                    background-color: rgba(11, 95, 255, 0.1) !important;
                    box-shadow: 0 0 0 3px rgba(11, 95, 255, 0.2) !important;
                    z-index: 1000 !important;
                }
                
                /* Keep dropdown visible when child has focus */
                .dropdown:focus-within .dropdown-menu,
                .nav-item:focus-within .dropdown-menu {
                    display: block !important;
                    visibility: visible !important;
                }
            `;
            document.head.appendChild(style);
        }
    }

    function init() {
        cookieAgreement();

        // from liferay
        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                mutation.addedNodes.forEach((node) => {
                    if (!(node instanceof HTMLElement)) return;
                    const loginInput = node.querySelector?.(
                        '#_com_liferay_login_web_portlet_LoginPortlet_login'
                    );
                    if (loginInput) {
                        loginInput.value = "";
                    }
                });
            });
        });
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });

        document.addEventListener("DOMContentLoaded", () => {
            const loginInput = document.querySelector(
                '#_com_liferay_login_web_portlet_LoginPortlet_login'
            );
            if (loginInput) loginInput.value = "";
        });

        document.addEventListener('DOMContentLoaded', makeNavAccessible);
        setTimeout(makeNavAccessible, 500);
        setTimeout(makeNavAccessible, 1000);

        const tabindexObserver = new MutationObserver(function (mutations) {
            mutations.forEach(function (mutation) {
                if (mutation.type === 'attributes' && mutation.attributeName === 'tabindex') {
                    const element = mutation.target;
                    if (element.matches('.nav-link, .navbar-nav a, .dropdown-item')) {
                        if (element.getAttribute('tabindex') === '-1') {
                            element.setAttribute('tabindex', '0');
                        }
                    }
                }
            });
        });

        setTimeout(function () {
            tabindexObserver.observe(document.body, {
                attributes: true,
                attributeFilter: ['tabindex'],
                subtree: true
            });
        }, 100);
    }


    AUI().ready((function () {
        if (window.__pcuel_init_loaded) return;
        window.__pcuel_init_loaded = true;

        init();
    }));
})();


(function () {
    function shallowEqual(obj1, obj2) {
        const keys1 = Object.keys(obj1);
        const keys2 = Object.keys(obj2);

        if (keys1.length !== keys2.length) {
            return false;
        }

        for (const key of keys1) {
            if (obj1[key] !== obj2[key]) {
                return false;
            }
        }

        return true;anot
    }

    /**
     * Ensures the webchat script is loaded only once.
     * @returns {Promise<void>} Resolves when the script is loaded.
     */
    function ensureChatScriptLoaded() {
        return new Promise((resolve, reject) => {
            const cfg = window.PCUEL_CHATBOT_CONFIG;
            if (!cfg) {
                console.error('chatbot config not found');
                return;
            }

            if (document.getElementById('pcuel-webchat-script')) {
                if (shallowEqual(cfg, window.__pcuel_chatbot_config)) {
                    resolve();
                    return;
                } else {
                    document.querySelectorAll('#pcuel-webchat-script').forEach(function (el) {
                        el.remove();
                    });
                }
            }

            console.log('Loading webchat script', cfg);

            const langId = Liferay.ThemeDisplay.getLanguageId();
            const siteLang = langId && langId.startsWith("ro") ? "ro" : "en";

            const s = document.createElement('script');
            s.id = 'pcuel-webchat-script';
            s.type = 'text/javascript';
            s.src = cfg.src;
            s.setAttribute('clientkey', cfg.clientKey);
            s.setAttribute('projectid', cfg.projectId);
            s.setAttribute("site_language", siteLang);

            if (cfg.token) {
                s.setAttribute('token', cfg.token);
            }

            window.__pcuel_chatbot_config = {...cfg}

            s.onload = () => resolve();
            s.onerror = () => reject(new Error('Failed to load webchat.js'));

            document.head.appendChild(s);
        });
    }

    /**
     * Initializes or refreshes the chat widget after SPA navigation.
     */
    function initOrRefreshChat() {
        ensureChatScriptLoaded()
            .then(() => {
                if (window.WebChat && typeof window.WebChat.init === 'function') {
                    window.WebChat.init();
                    return;
                }

                window.dispatchEvent(new Event('webchat:refresh'));
            })
            .catch((e) => {
                console.warn('[webchat] init failed:', e);
            });
    }

    // Initial load
    initOrRefreshChat();

    // Re-initialize after Liferay SPA navigation
    if (window.Liferay && typeof Liferay.on === 'function') {
        // Liferay.on('endNavigate', function() {
        //     console.log('endNavigate', window.location.pathname);
        //     if (window.location.pathname.includes('/c/portal/login')) {
        //         window.location.reload();
        //     } else {
        //         initOrRefreshChat();
        //     }
        // });
        // Liferay.on('allPortletsReady', function() {
        //     console.log('allPortletsReady', window.location.pathname);
        //     initOrRefreshChat();
        // });
    }
})();

Liferay.Portlet.ready((function (e, n) { }));

Liferay.on("allPortletsReady", (function () { }));
//# sourceMappingURL=main.js.map

// add client side validation for update password form
(function () {

    function attachLiferayValidator(policy) {
        const passwordInput = document.querySelector('#password1, [name$="_password1"]');
        if (!passwordInput) {
            console.warn('Password input not found');
            return;
        }

        const form = passwordInput.closest('form');
        if (!form || !form.id) {
            console.warn('Password input not in a form');
            return;
        }

        let errorContainer = document.querySelector('#password-policy-errors');

        if (!errorContainer) {
            errorContainer = document.createElement('div');
            errorContainer.id = 'password-policy-errors';
            errorContainer.className = 'form-feedback-item form-validator-stack help-block';
            errorContainer.style.display = 'none';

            passwordInput.insertAdjacentElement('afterend', errorContainer);
        }

        const formGroup = passwordInput.closest('.form-group');

        function validate(password) {
            const errors = [];

            if (policy.minLength && password.length < policy.minLength) {
                errors.push(Liferay.Language.get('that-password-is-too-short').replace('{0}', policy.minLength));
            }

            if (policy.minUpperCase) {
                const count = (password.match(/[A-Z]/g) || []).length;
                if (count < policy.minUpperCase) {
                    errors.push(Liferay.Language.get('that-password-must-contain-at-least-x-uppercase-characters').replace('{0}', policy.minUpperCase));
                }
            }

            if (policy.minLowerCase) {
                const count = (password.match(/[a-z]/g) || []).length;
                if (count < policy.minLowerCase) {
                    errors.push(Liferay.Language.get('that-password-must-contain-at-least-x-lowercase-characters').replace('{0}', policy.minLowerCase));
                }
            }

            if (policy.minNumbers) {
                const count = (password.match(/[0-9]/g) || []).length;
                if (count < policy.minNumbers) {
                    errors.push(Liferay.Language.get('that-password-must-contain-at-least-x-numbers').replace('{0}', policy.minNumbers));
                }
            }

            if (policy.minSymbols) {
                const count = (password.match(/[^a-zA-Z0-9]/g) || []).length;
                if (count < policy.minSymbols) {
                    errors.push(Liferay.Language.get('that-password-must-contain-at-least-x-symbols').replace('{0}', policy.minSymbols));
                }
            }

            if (policy.regex) {
                const regex = new RegExp(policy.regex);
                if (!regex.test(password)) {
                    errors.push(Liferay.Language.get('that-password-does-not-comply-with-the-regular-expression').replace('{0}', policy.regex));
                }
            }

            return errors;
        }

        function renderErrors(errors) {
            if (!errors.length) {
                errorContainer.style.display = 'none';
                errorContainer.innerHTML = '';
                passwordInput.classList.remove('error-field');
                if (formGroup) {
                    formGroup.classList.remove('has-error');
                }
                return;
            }

            errorContainer.style.display = 'block';
            errorContainer.innerHTML = errors
                .map(e => `<div class="form-feedback-item">${e}</div>`)
                .join('');
        }

        function applyErrorState(errors) {
            const submitButton = form.querySelector(
                'button[type="submit"], input[type="submit"]'
            );

            if (!errors.length) {
                passwordInput.classList.remove('error-field');
                if (formGroup) {
                    formGroup.classList.remove('has-error');
                }
                if (submitButton) {
                    submitButton.disabled = false;
                }
                return;
            }

            passwordInput.classList.remove('success-field');
            passwordInput.classList.add('error-field');

            if (formGroup) {
                formGroup.classList.remove('has-success');
                formGroup.classList.add('has-error');
            }
            if (submitButton) {
                submitButton.disabled = true;
            }
        }

        const liferayForm = Liferay.Form?.get(form.id);
        if (!liferayForm) {
            passwordInput.addEventListener('input', function () {
                const errors = validate(passwordInput.value);
                renderErrors(errors);
                applyErrorState(errors);
            });
            passwordInput.addEventListener('blur', function () {
                const errors = validate(passwordInput.value);
                renderErrors(errors);
                applyErrorState(errors);
            });
            return;
        }

        const validator = liferayForm.formValidator;
        const originalValidateField = validator.validateField;

        validator.validateField = function(field) {
            const result = originalValidateField.apply(this, arguments);
            if (field && field.get && field.get('name').endsWith('password1')) {
                const errors = validate(passwordInput.value);
                renderErrors(errors);
                applyErrorState(errors);
                return !errors.length && result;
            }
            return result;
        };

        passwordInput.addEventListener('input', function () {
            const errors = validate(passwordInput.value);
            renderErrors(errors);
            applyErrorState(errors);
        });
    }

    function init() {
        const passwordField = document.querySelector('#password1, [name$="_password1"]');
        if (!passwordField) {
            return;
        }

        Liferay.Util.fetch('/o/pcuel/password-policy')
            .then(r => r.json())
            .then(policy => {
                attachLiferayValidator(policy);
            })
            .catch((e) => {
                console.warn("Password policy could not be loaded.", e);
            });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }

})();